export var AttendanceRecordType;
(function (AttendanceRecordType) {
    AttendanceRecordType["NORMAL"] = "normal";
    AttendanceRecordType["MISSING_STAMP"] = "missing_stamp";
    AttendanceRecordType["REQUEST_REJECTED"] = "request_rejected";
    AttendanceRecordType["PENDING_REQUEST"] = "pending_request";
    AttendanceRecordType["HOLIDAY"] = "holiday";
    AttendanceRecordType["NONE"] = "not_entered";
    AttendanceRecordType["TODAY"] = "today";
    AttendanceRecordType["REQUEST_APPROVED"] = "request_approved";
    AttendanceRecordType["ADMIN_MODIFIED"] = "admin_modified";
})(AttendanceRecordType || (AttendanceRecordType = {}));
export var AttendanceRequestStatus;
(function (AttendanceRequestStatus) {
    AttendanceRequestStatus["PENDING"] = "pending";
    AttendanceRequestStatus["APPROVED"] = "approved";
    AttendanceRequestStatus["REJECTED"] = "rejected";
})(AttendanceRequestStatus || (AttendanceRequestStatus = {}));
export var AttendanceDisplayStatus;
(function (AttendanceDisplayStatus) {
    AttendanceDisplayStatus["WORKED"] = "worked";
    AttendanceDisplayStatus["PENDING_REQUEST"] = "pending_request";
    AttendanceDisplayStatus["NOT_ASSIGNED"] = "not_assigned";
    AttendanceDisplayStatus["MISSING_STAMP"] = "missing_stamp";
    AttendanceDisplayStatus["MISSING_CHECKOUT"] = "missing_checkout";
    AttendanceDisplayStatus["HOLIDAY"] = "holiday";
    AttendanceDisplayStatus["WORKING"] = "working";
    AttendanceDisplayStatus["NOT_ENTERED"] = "not_entered";
})(AttendanceDisplayStatus || (AttendanceDisplayStatus = {}));
